import { scanHistorySchema, scanDetailsSchema, scanLogsSchema, organizationScanListQuerySchema, scanUsersResponseSchema, } from '../contracts/scans';
import { paginationSchema } from '../contracts/helpers';
import { parseSchema } from '../errors';
/**
 * List scan history with pagination
 */
export async function listScanHistory(client, params = {}) {
    const validatedParams = parseSchema(paginationSchema, params);
    const response = await client.get('/scans', { params: validatedParams });
    return parseSchema(scanHistorySchema, response);
}
/**
 * Get details for a specific scan
 */
export async function getScanDetails(client, scanId) {
    const response = await client.get(`/scans/${scanId}`);
    return parseSchema(scanDetailsSchema, response);
}
/**
 * Create a new scan (requires API key authentication)
 */
export async function createScan(client, scanData) {
    const response = await client.post('/scans', {
        filePath: scanData.filePath,
        fullPath: scanData.fullPath || scanData.filePath,
        content: scanData.content,
        fileType: scanData.fileType,
        timestamp: scanData.timestamp || Date.now(),
        clientVersion: scanData.clientVersion,
        ...(scanData.extraData && { extraData: scanData.extraData }),
        ...(scanData.gitOriginUrl != null && {
            gitOriginUrl: scanData.gitOriginUrl,
        }),
        ...(scanData.repoRoot != null && { repoRoot: scanData.repoRoot }),
    });
    // The scan creation endpoint returns a simple response
    const responseData = response;
    return {
        id: responseData.id || '',
        message: responseData.message || 'Scan created successfully',
    };
}
/**
 * List organization scan history with pagination
 */
export async function listOrganizationScanHistory(client, organizationId, params = {}) {
    const validatedParams = parseSchema(organizationScanListQuerySchema, params);
    const response = await client.get(`/organizations/${organizationId}/scans`, {
        params: validatedParams,
    });
    return parseSchema(scanHistorySchema, response);
}
/**
 * Get a specific organization scan by ID
 */
export async function getOrganizationScanDetails(client, organizationId, scanId) {
    const response = await client.get(`/organizations/${organizationId}/scans/${scanId}`);
    return parseSchema(scanDetailsSchema, response);
}
/**
 * Get users associated with scans for a specific alert within an organization.
 *
 * The alert name is the composite `<subPolicyKey>::<type>` title key the Top
 * Alerts widget emits. `encodeURIComponent` below keeps the `::` intact on
 * the wire as `%3A%3A`.
 */
export async function getOrganizationScanUsers(client, organizationId, alertName, dateRange) {
    const params = dateRange
        ? { from: dateRange.from, to: dateRange.to }
        : undefined;
    const response = await client.get(`/organizations/${organizationId}/scans/alerts/${encodeURIComponent(alertName)}/users`, { params });
    return parseSchema(scanUsersResponseSchema, response);
}
/**
 * Get scan logs (scan details with issues) for a specific organization scan.
 * Used for rendering scan data in scan log tables without user info.
 */
export async function getOrganizationScanLogs(client, organizationId, scanId) {
    const response = await client.get(`/organizations/${organizationId}/scans/${scanId}/logs`);
    return parseSchema(scanLogsSchema, response);
}
//# sourceMappingURL=scans.js.map